{
	"title": "Dostupné materiály",
	"showAllTitle": "Ukaž všechny materiály",
	"table": {
		"material": "Materiál",
		"invoicedQuantity": "Fakturované množství",
		"remainingForTransfer": "Zbývá k vytvoření prohlášení",
		"fetchError": "Materiály se nepodařilo načíst",
		"noMaterials": {
			"title": "Nejsou k dispozici žádné materiály",
			"description": "Momentálně nemáte na {{productName}} dostupné žádné materiály. Obraťte se prosím na svého obchodního zástupce a přidejte smlouvu(y) do svého účtu."
		}
	}
}
